import * as React from "react";
import { cx } from "utils/join-classnames";
import { Icon } from "ui/components/atoms";
import $ from "./Table.module.scss";

type WidthType = number | "filled" | "min";
type SortOrderType = "ascending" | "descending";
type TableHeadProps = {
    sortable?: boolean;
    children: React.ReactNode;
};
type TableLabelProps = {
    label: string;
    width?: WidthType;
    sortable?: boolean;
    sortOrder?: SortOrderType | false;
    sortActive?: boolean;
    onClick?: () => void;
};
type TableCellProps = {
    width?: WidthType;
    children: React.ReactNode;
};
type Props = {
    children: React.ReactNode;
};

const TableContainer: React.FC<Props> = (props) => {
    const { children } = props;

    return <div className={$.table}>{children}</div>;
};
const TableHead: React.FC<TableHeadProps> = (props) => {
    const { children, sortable } = props;

    return (
        <div className={cx($.table__head, sortable && $.is__sortable)}>
            {children}
        </div>
    );
};
const TableBody: React.FC<Props> = (props) => {
    const { children } = props;

    return <div className={$.table__body}>{children}</div>;
};
const TableRow: React.FC<Props> = (props) => {
    const { children } = props;

    return <div className={$.row}>{children}</div>;
};
const TableCell: React.FC<TableCellProps> = (props) => {
    const { children, width } = props;
    const labelStyle: React.CSSProperties | undefined =
        width !== "filled"
            ? {
                  width: `${width}em`,
              }
            : undefined;

    return (
        <div
            style={labelStyle}
            className={cx($.cell, width === "filled" && $.is__filled)}
        >
            {children}
        </div>
    );
};
const TableLabel: React.FC<TableLabelProps> = (props) => {
    const {
        label,
        sortable,
        sortOrder = "ascending",
        sortActive,
        onClick,
        width,
    } = props;
    const labelClassName = cx(
        $.label,
        sortable && $.is__sortable,
        sortActive && $.is__active,
        sortOrder === "ascending" && $.is__ascending,
        sortOrder === "descending" && $.is__descending,
        width === "filled" && $.is__filled,
    );
    const labelStyle: React.CSSProperties | undefined =
        width !== "filled"
            ? {
                  width: `${width}em`,
              }
            : undefined;

    return (
        <div
            role="presentation"
            className={labelClassName}
            onClick={onClick}
            style={labelStyle}
        >
            <div className={$.label__inner}>
                {label}
                {sortable && (
                    <span className={$.label__icon}>
                        {sortOrder === "descending" ? (
                            <Icon name="dropdown-up" />
                        ) : (
                            <Icon name="dropdown-down" />
                        )}
                    </span>
                )}
            </div>
        </div>
    );
};

export {
    WidthType,
    SortOrderType,
    TableContainer as Container,
    TableHead as Head,
    TableBody as Body,
    TableRow as Row,
    TableCell as Cell,
    TableLabel as Label,
};
